import { useEffect, useRef } from "react";
import type { Answers } from "./types";

/**
 * Meldet Antwort-Änderungen an die Eltern-Komponente — 1:1 das Muster aus
 * `RisikoKfzStepForm` (Skip-First-Ref), nur an einer Stelle statt in jedem
 * Step-Formular kopiert.
 *
 * Der erste Lauf (Mount) wird bewusst übersprungen: sonst meldete allein das
 * Öffnen des Formulars „ungespeicherte Eingaben", obwohl der User nichts
 * getippt hat.
 */
export function useAnswersChangeSignal(
  answers: Answers,
  onAnswersChange?: (answers: Answers) => void,
): void {
  const skipFirstRef = useRef(true);
  useEffect(() => {
    if (skipFirstRef.current) {
      skipFirstRef.current = false;
      return;
    }
    onAnswersChange?.(answers);
  }, [answers, onAnswersChange]);
}
